import { OrderType } from '@exam-management/graphql';
import {
  QBankStructureCVModalAction,
  useQBankStructureCVModal,
} from '@exam-management/qbank-structure-cv';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { useParams } from '@exam-management/router';
import {
  UserList,
  UserListVariants,
  type UserRow,
  type UserListDefColumn,
} from '@exam-management/user-management';
import type { GridCellParams, GridEventListener } from '@shared/components';

import { MoreActionButton } from '../_components';

const initialQBSMemberListParams = {
  field: 'firstname',
  sort: OrderType.Asc,
  page: 0,
  pageSize: 10,
  role: '',
};

export function QBankStructureSettingMemberList() {
  const { setAction, setEditUserCVDetails } = useQBankStructureCVModal();
  const { qBankStructureInformation } = useQBankStructure();

  const { structureId = '' } = useParams('/qbank-structures/:structureId/setting');

  const moreActionCol: UserListDefColumn[] = [
    {
      field: 'moreAction',
      headerName: '',
      width: 68,
      renderCell: (params) => {
        const userDetails = params.row;
        return (
          <MoreActionButton
            createdBy={qBankStructureInformation.createdBy}
            userDetails={userDetails}
            structureId={structureId}
          />
        );
      },
      sortable: false,
    },
  ];

  const handleCellClick: GridEventListener<'cellClick'> = (params: GridCellParams<UserRow>) => {
    if (params.field !== 'moreAction') {
      setEditUserCVDetails(params.row);
      setAction(QBankStructureCVModalAction.EDIT_CONTENT_VISIBILITY_OF_MEMBER);
    }
  };

  return (
    <UserList
      variant={UserListVariants.QBANK_STRUCTURE_MEMBERS}
      moreColumns={moreActionCol}
      options={{ withAppRoleFilter: false, withStatusFilter: false, withSearch: true }}
      DataGridProps={{
        columnVisibilityModel: {
          lastLoginAt: false,
        },
        onCellClick: handleCellClick,
      }}
      initialDataGridParams={initialQBSMemberListParams}
    />
  );
}
